import axios from '@axios';
import { PollingTaskStatus } from '@redux/slices/polling-status';

interface ImportCotasStatusResponse {
    jobId: string;
    status: 'AGUARDANDO' | 'PROCESSANDO' | 'CONCLUIDO' | 'ERRO';
    linhasProcessadas: number;
    erros: string[];
    iniciadoEm: string | null;
    finalizadoEm: string | null;
}

export const checkImportCotasArquivo = async (
    jobId: string,
): Promise<PollingTaskStatus> => {
    const { status: httpStatus, data } = await axios.get<ImportCotasStatusResponse>(
        `/cotas-cliente/importar/status/${jobId}`,
    );

    if (httpStatus !== 200) throw new Error('Erro ao verificar status do import');

    const meta: Record<string, string> = {};
    if (data.iniciadoEm) meta.iniciadoEm = data.iniciadoEm;
    if (data.finalizadoEm) meta.finalizadoEm = data.finalizadoEm;
    meta['Linhas processadas'] = String(data.linhasProcessadas ?? 0);

    if (data.status === 'CONCLUIDO') {
        return {
            status: 'success',
            message: 'Importação concluída com sucesso',
            meta,
        };
    }

    if (data.status === 'ERRO') {
        return {
            status: 'error',
            message: 'Erro na importação',
            errors: data.erros?.length ? data.erros : ['Erro desconhecido'],
            meta,
        };
    }

    return {
        status: 'loading',
        message: data.status === 'AGUARDANDO' ? 'Aguardando' : 'Processando',
        meta,
    };
};
